// Full-screen gallery untuk pilih template + buka saved project.

import { STRINGS } from '@tm/shared'
import { listProjects } from '../store/ProjectRepository.js'

export async function loadManifest() {
  const res = await fetch('/templates/manifest.json')
  if (!res.ok) throw new Error(`Gagal memuat manifest: ${res.status}`)
  return res.json()
}

export async function loadTemplate(entry) {
  const res = await fetch(entry.path)
  if (!res.ok) throw new Error(`Gagal memuat template ${entry.id}: ${res.status}`)
  return res.json()
}

export async function mountTemplateSelector({ onSelectTemplate, onSelectProject }) {
  const overlay = document.createElement('div')
  overlay.className = 'tm-template-selector'
  overlay.setAttribute('role', 'dialog')
  overlay.setAttribute('aria-label', STRINGS.templateSelectorTitle)

  overlay.innerHTML = `
    <header class="tm-template-selector__header">
      <h1>${STRINGS.templateSelectorTitle}</h1>
      <button class="tm-template-selector__close" aria-label="${STRINGS.close}">✕</button>
    </header>
    <div class="tm-template-selector__grid" id="tm-ts-grid"></div>
  `

  const grid = overlay.querySelector('#tm-ts-grid')

  const manifest = await loadManifest()
  const projects = await listProjects()

  for (const entry of manifest.templates) {
    const tpl = await loadTemplate(entry)
    const tile = createTemplateTile(tpl)
    tile.addEventListener('click', () => {
      onSelectTemplate(tpl)
    })
    grid.appendChild(tile)
  }

  for (const proj of projects) {
    const tile = createProjectTile(proj)
    tile.addEventListener('click', () => {
      onSelectProject(proj)
    })
    grid.appendChild(tile)
  }

  if (projects.length === 0 && manifest.templates.length === 0) {
    const empty = document.createElement('p')
    empty.className = 'tm-template-selector__empty'
    empty.textContent = STRINGS.templateSelectorEmpty
    grid.appendChild(empty)
  }

  overlay.querySelector('.tm-template-selector__close').addEventListener('click', () => {
    overlay.remove()
  })

  return overlay
}

function createTemplateTile(tpl) {
  const tile = document.createElement('button')
  tile.className = 'tm-template-tile'
  tile.setAttribute('data-template-id', tpl.id)
  tile.innerHTML = `
    <img src="${tpl.thumbnail}" alt="" class="tm-template-tile__thumb" />
    <h2 class="tm-template-tile__title">${tpl.title}</h2>
    <p class="tm-template-tile__desc">${tpl.description}</p>
    <span class="tm-template-tile__cta">▶ ${STRINGS.play}</span>
  `
  return tile
}

function createProjectTile(proj) {
  const tile = document.createElement('button')
  tile.className = 'tm-project-tile'
  tile.setAttribute('data-project-id', proj.id)
  const updated = new Date(proj.updatedAt).toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  })
  const meta = STRINGS.projectTileMeta.replace('%s', updated).replace('%d', proj.totalPlays || 0)
  tile.innerHTML = `
    <div class="tm-project-tile__icon">📁</div>
    <h2 class="tm-project-tile__title">${proj.name || 'Proyek'}</h2>
    <p class="tm-project-tile__meta">${meta}</p>
  `
  return tile
}
